import React, {
  useCallback,
  Fragment,
  useContext,
  useState,
  useEffect,
  useMemo,
  memo,
} from "react";
import "./styles.css";
import ConfirmationPrompt from "components/prompts/confirmationPrompt";
//SVG
import { ReactComponent as SpecialNote } from "common/assets/svg/customize.svg";
// import { ReactComponent as HeartFilled } from "common/assets/svg/heartFilled.svg";
// import { ReactComponent as Veg } from "common/assets/svg/veg.svg";
// import { ReactComponent as NonVeg } from "common/assets/svg/nonveg.svg";
import { ReactComponent as Loader } from "common/assets/svg/loader.svg";
import VegDishIcon from "common/assets/images/dishPlaceholder.png";
import SalonPlaceHolder from "common/assets/images/salon.png";
import {
  Customization,
  Ingredient,
  OrderType,
  RestaurantMenuItem,
} from "common/features/restaurant/restaurantModels";
import MenuItemDiscriptionPrompt from "components/prompts/menuItemDiscription";

// import dishImage from "common/assets/images/temp/dish.png";
// import { ReactComponent as Minus } from "common/assets/svg/minus.svg";
// import { ReactComponent as Plus } from "common/assets/svg/plus.svg";
import { useHistory, useLocation, useParams } from "react-router";
//import CustomizeCart from "pages/order/cartCustomisation";
import { useDispatch, useSelector } from "react-redux";
import {
  addCartItem,
  decrementCartItem,
  incrementCartItem,
  updateCartItem,
  removeCartItem,
  showItemMaxCountPrompt,
  startItemCustomisation,
  storeMenuItem,
  startEmptyCart,
  clearCutomizationItem,
} from "common/features/cart/cartActions";

import { RootState } from "common/rootReducer";
import { CartItem, CartItemOption } from "common/features/cart/cartModels";
import PriceText from "components/priceText";
import ItemCountSpinner from "components/InputComponents/ItemCountSpinner";
import {
  getRestaurantMenuCustomisationDineInURL,
  getRestaurantMenuCustomisationURL,
  getRestaurantMenuPreviewItemURL,
} from "common/utils/route-util";
import {
  getCustomisationType,
  getDecimalPlacedPriceString,
  getDefaultCustomisations,
} from "common/utils/menu-helper-utils";
import { isInCurrentWindow } from "common/utils/date-time-helper-utils";
import OfferList from "pages/offer";
import PriceOffer from "components/PriceOffer";
import LoginRequestPopup from "../../components/prompts/loginRequestPrompt";
import { AuthContext } from "common/services/auth-service";
import moment from "moment";
import ConfirmationPopup from "components/ConfirmationPopup";
import { startEmptyCartOrder } from "common/features/order/orderActions";
import { useIsEventOrders } from "common/features/selectors";
interface DishCardProps {
  itemDetail: RestaurantMenuItem;
  customizable: boolean;
  setShowSpeicalNotePromptID: any;
  // isSpecialNoteAdded: boolean;
  getMenuItemImageURL: any;
  menuView: boolean;
  menuAdd: boolean;
  menuType?: String;
  setCustomisationPopup?: any;
  setCustomisationItemId?: any;
  setPreviewItemPopup?:any;
  ItemUpdate(itemId: string, quantity: string): void;
  cutOffTimeExceeds?:boolean;
}

const DishCard = memo((props: DishCardProps) => {
  // console.log(props, "checking props");
  //const [isFavourite, setIsFavourite] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = window.innerWidth <= 500;

  useEffect(() => {
    // todo: optimise
    if (!menuType) {
      menuType = props.menuType;
    }
  });
  const [is_add, setisadd] = useState(false);
  const AppAuth = useContext(AuthContext);
  // let  checking = false;
  const [loginRequestPopup, setloginRequestPopup] = useState(false);
  let {
    merchantType,
    restaurantSlug,
    menuType,
    merchantSlug,
    orderId,
    tableId,
    
  } = useParams<any>();
  const {cutOffTimeExceeds} = props;
  
  const [openDiscriptionPopup, setOpenDiscriptionPopup] = useState(false);
  const [currentUTCTime, setCurrentTime] = useState(
    new Date().toISOString().split("T")[1].slice(0, 5).split(":")
  );
  const cartItems = useSelector((state: RootState) => state.cart.cart.items);
  // console.log(cartItems, "cartItems");
  const [itemprice, setItemprice] = useState(props.itemDetail.price);
  const cartvalue = useSelector(
    (state: RootState) => state.offer.checkofferresult
  );

  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );
  const isEventOrders = useIsEventOrders();
  // useEffect(()=>{

  //   if (cartvalue.length > 0&& cartvalue[0]?.offerAttributes.itemDetails.itemCode ===
  //         props.itemDetail.itemId
  //     ) {
  //       props.ItemUpdate(props.itemDetail.itemId,String(Number(props.itemDetail.price) - cartvalue[0].maxDiscount))
  //       console.log("checking useEffect32",String(Number(itemprice) - cartvalue[0].maxDiscount))
  //       setItemprice(String(Number(props.itemDetail.price) - cartvalue[0].maxDiscount))
  //     }

  // },[cartvalue])
  useEffect(() => {
    let item = cartItems.filter(
      (item) => item.itemId == props.itemDetail.itemId
    );

    if(item.length > 0){
      setIsCartAdded(true)
    if (item.length > 0 && item[0]?.comment?.length > 0) {
      setIsSpecialNoteAdded(true);
    } else {
      setIsSpecialNoteAdded(false);
    }
  }else{
    setIsCartAdded(false)
  }
  }, [cartItems]);

  // console.log(cartItems,"---->checking the cartitems in dishcard")

  const [isSpecialNoteAdded, setIsSpecialNoteAdded] = useState(false);
  const [isCartAdded, setIsCartAdded] = useState(false);


  const cartData = useSelector((state: RootState) => {
    return state.cart.cart.items.find((item) => {
      if (item.itemId == props.itemDetail.itemId) {
        // console.log('cartData - ', item);
      }
      return item.itemId == props.itemDetail.itemId;
    });
  });
  const lastIndividualItemIndex = useSelector((state: RootState) =>
    state.cart.cart.items
      .map((item) => item.itemId)
      .lastIndexOf(props.itemDetail.itemId)
  );
  const cartMenuDefaultTax = useSelector(
    (state: RootState) => state.cart.cartMenuDefaultTax
  );
  const checkforofferloading = useSelector(
    (state: RootState) => state.offer.checkOfferLoading
  );
  //console.log("checkforofferloading--",checkforofferloading)
  const individualCustomisedItemCount = useSelector(
    (state: RootState) =>
      state.cart.cart.items.filter((item) => {
        return item.itemId == props.itemDetail.itemId;
      }).length
  );

  const restaurantCountry = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );

  const currentRestaurantDetail = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  // Check if this Item is Customised Individually
  const itemIndividualCustomizationEnabled = useSelector((state: RootState) =>
    state.cart.customisedIndividualItems.includes(props.itemDetail.itemId)
  );

  // Check if this Item is already saved in cart with some customisation
  const isItemCustomisationSaved = useSelector((state: RootState) =>
    state.cart.customisationSavedItems.includes(props.itemDetail.itemId)
  );
  const isItemCustomisedIndividually = useSelector((state: RootState) =>
    state.cart.customisedIndividualItems.includes(props.itemDetail.itemId)
  );

  // Get Stored Customisation
  const savedItemDetails = useSelector((state: RootState) =>
    state.cart.cart.items.filter(
      (item) => item.itemId == props.itemDetail.itemId
    )
  );

  const cartRestaurantSlug = useSelector(
    (state: RootState) => state.cart.cartRestaurantSlug
  );

  const cartMenuType = useSelector(
    (state: RootState) => state.cart.cartMenuType
  );

  const customerId = useSelector((state: RootState) => state.auth.user);

  const hasCustomization = useCallback(() => {
    return (
      props.itemDetail.customization &&
      props.itemDetail.customization.length > 0 &&
      props.itemDetail.customization?.filter((item) => item.typeAvailable === 1)
        .length > 0
    );
  }, [props]);

  const getItemTax = useCallback(() => {
    return props.itemDetail.isDefaultItemTax && cartMenuDefaultTax
      ? cartMenuDefaultTax
      : props.itemDetail.tax || [];
  }, [props, cartMenuDefaultTax]);

  const restaurantOrderTypes = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.orderTypes
  );

  const restaurantOrderTypeId = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTypeId
  );

  const isContactlessDineInOrder = useMemo(() => {
    if (restaurantOrderTypes) {
      return (
        (currentRestaurantDetail.dining == 2 ||
          currentRestaurantDetail.dining == 3) &&
        restaurantOrderTypes.find(
          (orderType: OrderType) => orderType.typeGroup == "D"
        )?.id == restaurantOrderTypeId &&
        tableId &&
        tableId.length > 0
      );
    }
    return false;
  }, [restaurantOrderTypeId, restaurantOrderTypes, currentRestaurantDetail]);

  // For check Dine in is enabled or not in contactlessDinein
  const DineInTypeAvailable =
    isContactlessDineInOrder &&
    (
      restaurantOrderTypes &&
      restaurantOrderTypes.find(
        (orderType: OrderType) => orderType.typeGroup == "D"
      )
    )?.isEnabled === 0
      ? false
      : true;

  const customizeItem = useCallback(() => {
    //  console.log(props.itemDetail,"--->props.props.itemDetail")
    if(props.menuView){
      viewItem()
    }else if ((props.itemDetail)) {      
      dispatch(storeMenuItem(props.itemDetail));
      props?.setCustomisationItemId(props.itemDetail.itemId)

      const defaultItemCustomised = {
        itemId: props.itemDetail.itemId,
        itemName: props.itemDetail.itemName,
        itemAltName: props.itemDetail.itemAltName
          ? props.itemDetail.itemAltName
          : "",
        price: props.itemDetail.price,
        quantity: "1",
        // subTotal: getDecimalPlacedPriceString(props.itemDetail.price),
        subTotal: getItemPrice("discount"),
        comment: "",
        is_discount_applied: false,
        options: getDefaultCustomisations(props.itemDetail.customization || []),
        tax: getItemTax(),
        offer_data: null,
        offer_amount: Number(getItemPrice("discount")),
        availability: props.itemDetail.availability,
        isCustomizable:hasCustomization()
      } as CartItem;

      // console.log({defaultItemCustomised});
      

      //  console.log(defaultItemCustomised,props.itemDetail,"--->defaultItemCustomised");
      if (isItemCustomisationSaved && savedItemDetails.length > 0) {
        // console.log(isItemCustomisationSaved,savedItemDetails,"--->saveditemdetails");
        // Store Previous Customisations in Pseudo Cart
        if (isItemCustomisedIndividually) {
          // Individual Customisation -> Add new Object
          dispatch(
            startItemCustomisation([...savedItemDetails, defaultItemCustomised])
          );
        } else {
          // Entire Customisation -> Increment Quantity
          let entireItem = Object.assign({}, savedItemDetails[0]);
          const singleItemSubTotal =
            +entireItem.subTotal / +entireItem.quantity;
          entireItem.quantity = (+entireItem.quantity + 1).toString();
          entireItem.subTotal = (
            singleItemSubTotal * +entireItem.quantity
          ).toString();

          dispatch(startItemCustomisation([entireItem]));
        }
      } else {
        // Store Initial Customisation to Begin with Item Count as 1
        dispatch(startItemCustomisation([defaultItemCustomised]));
      }

      if ( props.itemDetail.enable) {
        props.setCustomisationPopup(true);

        // if (isContactlessDineInOrder || (tableId && props.menuAdd)) {
        //     props.setCustomisationPopup(true);
        // } else {
        //     props.setCustomisationPopup(true);
        // }
      } else if (props.itemDetail.description) {
        // console.log(props.itemDetail.description,"props.itemDetail.description");
        setOpenDiscriptionPopup(true);
      }

      const quantity =
        cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 0;
      if (props.itemDetail.itemBasedOffers !== null && customerId?.id) {
        props.ItemUpdate(props.itemDetail.itemId, String(quantity + 1));
      }
    }
  }, [props, isItemCustomisationSaved, savedItemDetails, hasCustomization]);

  const viewItem = useCallback(() => {
    dispatch(storeMenuItem(props.itemDetail));
    props?.setCustomisationItemId(props.itemDetail.itemId)

    const defaultItemCustomised = {
      itemId: props.itemDetail.itemId,
      itemName: props.itemDetail.itemName,
      itemAltName: props.itemDetail.itemAltName
        ? props.itemDetail.itemAltName
        : "",
      price: props.itemDetail.price,
      quantity: "1",
      // subTotal: getDecimalPlacedPriceString(props.itemDetail.price),
      subTotal: getItemPrice("discount"),
      comment: "",
      is_discount_applied: false,
      options: getDefaultCustomisations(props.itemDetail.customization || []),
      tax: getItemTax(),
      offer_data: null,
      offer_amount: Number(getItemPrice("discount")),
      availability: props.itemDetail.availability,
    } as CartItem;
    //  console.log(defaultItemCustomised,props.itemDetail,"--->defaultItemCustomised");
    if (isItemCustomisationSaved && savedItemDetails.length > 0) {
      // console.log(isItemCustomisationSaved,savedItemDetails,"--->saveditemdetails");
      // Store Previous Customisations in Pseudo Cart
      if (isItemCustomisedIndividually) {
        // Individual Customisation -> Add new Object
        dispatch(
          startItemCustomisation([...savedItemDetails, defaultItemCustomised])
        );
      } else {
        // Entire Customisation -> Increment Quantity
        let entireItem = Object.assign({}, savedItemDetails[0]);
        const singleItemSubTotal =
          +entireItem.subTotal / +entireItem.quantity;
        entireItem.quantity = (+entireItem.quantity + 1).toString();
        entireItem.subTotal = (
          singleItemSubTotal * +entireItem.quantity
        ).toString();
        dispatch(startItemCustomisation([entireItem]));
      }
    } else {
      // Store Initial Customisation to Begin with Item Count as 1
      // console.log(defaultItemCustomised,"SSSSSSSSSS");
      dispatch(startItemCustomisation([defaultItemCustomised]));
    }
    if ( props.itemDetail.enable) {
        if (isMobile) {
          history.push(
            getRestaurantMenuPreviewItemURL(
              merchantSlug,
              menuType,
              props.itemDetail.itemId
            ),
            {
              prevPath: location.pathname,
              loadLastIndex: true,
            }
          );
        } else {
          props.setPreviewItemPopup(true);
          props.setCustomisationPopup(true);
        }
    } 
}, [props, isItemCustomisationSaved, savedItemDetails]);
  // console.log("openCustomisation:::::", openCustomisation);
  const statusCardRoutes = [
    `/restaurant/${cartRestaurantSlug}/`,
    `/restaurant/${cartRestaurantSlug}/menu/${cartMenuType}`,
    `/restaurant/${cartRestaurantSlug}/table/${tableId}/menu/${cartMenuType}`,
    `/restaurant/${cartRestaurantSlug}/table/${tableId}/order/${orderId}/menu/${cartMenuType}`,
    `/salon/${cartRestaurantSlug}/menu/${cartMenuType}`,
    `/restaurant/${cartRestaurantSlug}`,
  ];

  const isCartRoute = statusCardRoutes.some((cartRoute) => {
    return location.pathname == cartRoute;
  });



  const addItem = useCallback(() => {
    const quantity =
      cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 0;
    if (quantity > 0 && !itemIndividualCustomizationEnabled) {
      // if (quantity == 10) {
      //   dispatch(showItemMaxCountPrompt());
      // } else {
        // console.log("object");
        const price: number =
          props.itemDetail.price && Number(props.itemDetail.price)
            ? Number(props.itemDetail.price) * (quantity + 1)
            : 0;
        dispatch(
          updateCartItem(
            props.itemDetail.itemId,
            String(getCartPrice(price)),
            false,
            quantity + 1
          )
        );
      //}
    } else if (quantity == 0) {
      dispatch(
        addCartItem({
          itemId: props.itemDetail.itemId,
          itemName: props.itemDetail.itemName,
          itemAltName: props.itemDetail.itemAltName
            ? props.itemDetail.itemAltName
            : "",
          price: props?.itemDetail?.offerPrice ? String(props?.itemDetail?.offerPrice) : props.itemDetail.price,
          quantity: "1",
          subTotal: getItemPrice("discount"),
          comment: "",
          is_discount_applied: false,
          options: [],
          tax: getItemTax(),
          offer_data: null,
          offer_amount: Number(getItemPrice("discount")),
          availability: props.itemDetail.availability,
          stockQuantity: props.itemDetail.stockQuantity,
          alertQuantity: props.itemDetail.alertQuantity,
          // offerPrice: props?.itemDetail?.offerPrice
        })
      );
    }

    if (props.itemDetail.itemBasedOffers !== null && customerId?.id) {
      props.ItemUpdate(props.itemDetail.itemId, String(quantity + 1));

      // dispatch(
      //   requestCheckOffers({
      //     customerId: customerId?.id,
      //     itemId: props.itemDetail.itemId,
      //     quantity: String(cartData + 1),
      //   })
      // );
    }
  }, [props]);

  const setIsOpen = (set: boolean) => {
    if (set) {
      setloginRequestPopup(false);
    }
  };

  const removeItem = useCallback(() => {
    const quantity =
      cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 0;
    // if (itemCount > 1) {
    //   itemCustomized
    //     ? dispatch(decrementCartItem(props.itemDetail.itemId))
    //     : dispatch(decrementCartItem(props.itemDetail.itemId));
    // } else if (itemCount == 1) {
    //   dispatch(removeCartItem(props.itemDetail.itemId));
    // }
    if (itemIndividualCustomizationEnabled) {
      if (individualCustomisedItemCount == 1) {
        dispatch(removeCartItem(props.itemDetail.itemId));
      } else {
        dispatch(
          removeCartItem(props.itemDetail.itemId, lastIndividualItemIndex)
        );
      }
    } else {
      if (quantity == 1) {
        dispatch(removeCartItem(props.itemDetail.itemId));
      } else {
        const price: number =
          props.itemDetail.price && Number(props.itemDetail.price)
            ? Number(props.itemDetail.price) * (quantity - 1)
            : 0;
        dispatch(
          updateCartItem(
            props.itemDetail.itemId,
            String(getCartPrice(price)),
            false,
            quantity - 1
          )
        );
        // dispatch(decrementCartItem(props.itemDetail.itemId));
      }
    }
    if (props.itemDetail.itemBasedOffers !== null && customerId?.id) {
      props.ItemUpdate(props.itemDetail.itemId, String(quantity - 1));

      // dispatch(
      //   requestCheckOffers({
      //     customerId: customerId?.id,
      //     itemId: props.itemDetail.itemId,
      //     quantity: String(cartData - 1),
      //   })
      // );
    }
  }, [props]);
  

  const getItemRowDetails = useCallback(() => {
    if (props.itemDetail.diet && props.itemDetail.diet.length > 0) {
      return props.itemDetail.diet?.map(
        (ingredient: Ingredient, index: number) => (
          <>
            <div className="food-content-img-content" key={index}>
              <div className="food-content-img-container">
                <img
                  src={props.getMenuItemImageURL(
                    ingredient.img,
                    ingredient.type.split("/")[1]
                  )}
                />
              </div>
            </div>
            <span className="ingredient-name">{ingredient.name}</span>
          </>
        )
      );
    } else if (
      props.itemDetail.ingredient &&
      props.itemDetail.ingredient.length > 0
    ) {
      return props.itemDetail.ingredient?.map(
        (ingredient: Ingredient, index: number) => (
          <div key={index} className="food-content-img-content">
            {ingredient.type && ingredient.img && (
              <>
                <div className="food-content-img-container">
                  <img
                    src={props.getMenuItemImageURL(
                      ingredient.img,
                      ingredient.type.split("/")[1]
                    )}
                  />
                </div>
                <span className="ingredient-name">{ingredient.name}</span>
              </>
            )}
          </div>
        )
      );
    }
  }, [props]);

  const get12HoursTime = (t24Stamp: string,nextAvailableDay:string) => {
    let timeString = t24Stamp.split("T")[1];
    if (timeString == "00:00:00") {
      return "Will be available tomorrow";
    } else {
      let hours = timeString.split(":")[0];
      let mins = timeString.split(":")[1];
      let median = "";
      if (parseInt(hours) >= 12) {
        hours = parseInt(hours) - 12 + "";
        median = "PM";
      } else {
        median = "AM";
      }  
      return (
        "Will be available on " + nextAvailableDay + " " + [hours, ":", mins, median].join(" ") + ""
      );
    }
  };
  const isItemAvailableOnCurrentServiceWindow = () => {
    let result = [true];
    if (props.itemDetail.availability) {
      result = props.itemDetail.availability?.map((hour) => {
        return isInCurrentWindow(
          currentUTCTime[0] + ":" + currentUTCTime[1],
          hour.startTime,
          hour.endTime
        );
      });
    }
    return result.some((available) => {
      return available == true;
    });
  };

  const getItemPrice = useCallback(
    (type?: string) => {
      // console.log(props.itemDetail,cartData,"checkinggg");
      let price =
        cartData && cartData.price && Number(cartData.price)
          ? Number(cartData.price)
          : props?.itemDetail?.offerPrice ? props?.itemDetail?.offerPrice : props.itemDetail.price && Number(props.itemDetail.price)
          ? Number(props.itemDetail.price)
          : 0;
      // console.log(cartData,price,props.itemDetail.price,"checking the cartfdata in itempricee")
      const quantity =
        cartData && Number(cartData.quantity) ? Number(cartData.quantity) : 1;
      //console.log( price,quantity, price * quantity,"checking cartdata");
      switch (type) {
        case "discount":
          if (cartData?.options.length === 0) {
            //console.log(cartData,"inside iff");
            price =
              cartData && cartData.subTotal && Number(cartData.subTotal)
                ? Number(cartData.subTotal)
                : price * quantity;
          } else {
            price =
              cartData && cartData.offer_amount && Number(cartData.offer_amount)
                ? Number(cartData.offer_amount)
                : price * quantity;

            //console.log(cartData,price,"inside iff");
          }
          break;

        case "totalPrice":
          price = price * quantity;
          break;

        default:
          break;
      }
      if (restaurantCountry.length > 0) {
        if (restaurantCountry == "US") {
          // console.log(price)
          return getDecimalPlacedPriceString(price);
        } else {
          //  console.log(  price,typeof 108,"checking")
          return getDecimalPlacedPriceString(price);
        }
      } else {
        return String(price);
      }
    },
    [restaurantCountry, props]
  );

  function getCartPrice(price: number) {
    if (restaurantCountry.length > 0) {
      if (restaurantCountry == "US") {
        // console.log(price)
        return getDecimalPlacedPriceString(price);
      } else {
        //  console.log(  price,typeof 108,"checking")
        return getDecimalPlacedPriceString(price);
      }
    } else {
      return price;
    }
  }

  const [open, setOpenPrompt] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const submitPrompt = (answer: boolean) => {
    if (answer) {
      dispatch(
        startEmptyCart({
          menuType: menuType,
          restaurantSlug: merchantSlug,
          clearCartItems: true,
          merchantType: merchantType,
        })
      );
      dispatch(startEmptyCartOrder())
      dispatch(clearCutomizationItem())
      addItem();
    }
    // answer &&
    //   dispatch(
    //     startEmptyCart({
    //       menuType: menuType,
    //       restaurantSlug: merchantSlug,
    //       clearCartItems: true,
    //       merchantType: merchantType,
    //     })
    //   );

    setIsPopupOpen(false);
  };

  const closePopup = () => {
    setOpenDiscriptionPopup(false);
  };

  function disableScroll() {
    // Get the current page scroll position
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    // if any scroll is attempted,
    // set this to the previous value
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  function enableScroll() {
    window.onscroll = function () {};
  }
  useEffect(() => {
    openDiscriptionPopup ? disableScroll() : enableScroll();
  }, [openDiscriptionPopup]);

  const [updatedMenu,setUpdatedMenu]= useState('')

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {    
    setIsPopupOpen(false);
  };

  const handleSubmitPopup = (menu:string) => {  
    setIsPopupOpen(false);
    dispatch(
      startEmptyCart({
        menuType: menuType,
        restaurantSlug: merchantSlug,
        clearCartItems: true,
        merchantType: merchantType,
        cartType: "CART",
      })
    );
    dispatch(startEmptyCartOrder())

    dispatch(clearCutomizationItem())
    addItem();
  };

  const orderTypes = useMemo(() => {
    return restaurantOrderTypes
      ? restaurantOrderTypes
          .filter(
            (orderType) =>
              // orderType.isEnabled == 1 &&
              orderType.typeGroup != "I" && orderType.typeGroup != "D"
          )
          .map((orderType) => orderType.typeName)
      : [];
  }, [restaurantOrderTypes]);


  const DescriptioContent = ({ content }) => {
    return (
      <div>
        {!!content && content?.length < 120  ? content : `${content?.substring(0, 120)}..  `+'See More...'}
    </div>
    );
  };

  const happyHoursPrice = props?.itemDetail?.offerPrice
  const normalPrice = props?.itemDetail?.price
  const happyHoursType = props?.itemDetail?.offerType

  return (
    <div id="menu-card-item-container" style={{ marginLeft: "5.3%" }}>
      <LoginRequestPopup
        isOpen={loginRequestPopup}
        visible={setIsOpen}
        title={" Login to avail offer"}
        subtext={" You need to login to apply this Offer."}
        cartUrl={
          isContactlessDineInOrder ? location.pathname : location.pathname
        }
      />
      <MenuItemDiscriptionPrompt
        isOpen={openDiscriptionPopup}
        closePrompt={closePopup}
      />
      {/* <ConfirmationPrompt
        question={"Switching order type or refreshing the page will result in clearing the cart. Do you want to proceed?"}
        isOpen={open}
        submitPrompt={submitPrompt}
        submitText={"Yes"}
        cancelText={"No"}
        InfoImage={null}
        type={"prompt"}
      /> */}
    {isPopupOpen && <ConfirmationPopup onClose={handleClosePopup} onSubmit={handleSubmitPopup} updatedMenu={updatedMenu} />}

      <div
        className="item-detail-container"
        style={isMobile ? { alignItems: "flex-start" } : {}}
      >
        <div
          className="item-detail-left"
          style={isMobile ? { flexBasis: "calc(100% - 95px)" } : {}}
        >
          <div className="itemHeading" onClick={customizeItem}>
            <span className="item-Name">
              {/* {props.itemDetail.veg ? <Veg /> : <NonVeg />} */}
              {props.itemDetail.itemName}
            </span>
            {props.itemDetail.itemAltName && (
              <div className="item-details-row" onClick={customizeItem}>
                <span id="item-name">
                  <span style={{ width: "100%", marginTop: "7px" }}>
                    {props.itemDetail.itemAltName}
                  </span>
                </span>
              </div>
            )}
            <div className="price-content">
              {!checkforofferloading ? (
                cartData?.is_discount_applied ? (
                  <div className="price-txt">
                    <PriceText
                      price={getItemPrice("totalPrice")}
                      isMenu={true}
                      dishCard={false}
                    />
                    <hr className="price_strike" /> 
                  </div>
                ) : (
                  <div className="price-txt">
                    <PriceText price={normalPrice} isMenu={true}  offerPrice={happyHoursPrice ? happyHoursPrice : 0} happyHoursType={happyHoursType} dishCard={true}/>
                  </div>
                )
              ) : props?.itemDetail?.itemBasedOffers &&
                props?.itemDetail?.itemBasedOffers.length !== 0 ? (
                <Loader height="55px" width="55px" className="price-loader" />
              ) : (
                <div className="price-txt">
                  <PriceText price={normalPrice} isMenu={true} offerPrice={happyHoursPrice ? happyHoursPrice : 0} happyHoursType={happyHoursType} dishCard={false}/>
                </div>
              )}
              {cartData?.is_discount_applied ? (
                <div className="price-txt">
                  <div className="">
                    <PriceText price={getItemPrice("discount")} isMenu={true} dishCard={false}/>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {!isMobile && (
              <div className="row-details" onClick={customizeItem}>
                <div className="row-details-content">{getItemRowDetails()}</div>
              </div>
            )}
            <div onClick={customizeItem}>
            <p className={"menu-item-description"}>
            {props.itemDetail.description && <DescriptioContent content={props?.itemDetail?.description} />}
                  {/* {props.itemDetail.description} <p>See more..</p> */}
              </p>
            {/* {!isMobile &&
              props.itemDetail &&
              (props.itemDetail.ingredient || props.itemDetail.diet) && (
                <>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      marginTop: "12px",
                    }}
                  >
                    <div
                      className="menu-item-description"
                  
                    >
                      {props.itemDetail.diet || ""}  <p>See more..</p>
                    </div>
                  </div>
                </>
              )} */}
            {/* {!isMobile &&
              !(props.itemDetail.diet && props.itemDetail.diet.length > 0) &&
              !(
                props.itemDetail.ingredient &&
                props.itemDetail.ingredient.length > 0
              ) && (
                <p className={"menu-item-description"}>
                  {props.itemDetail.description} <p>See more..</p>
                </p>
              )} */}
              </div>
          </div>
        </div>
        <div className={"item-detail-right"}>
          <div className="item-img-container" onClick={customizeItem}>
            {
              props.itemDetail?.itemImage ? (
                <img
                  src={props.getMenuItemImageURL(
                    props.itemDetail?.itemImage,
                    props.itemDetail?.itemType?.split("/")[1]
                  )}
                  alt="dishimage"
                />
              ) : null
              // <div style={{ zIndex: 1 }}>
              //   {merchantType == "restaurant" ? (
              //     <img className="dishPlaceholder" src={VegDishIcon} />
              //   ) : (
              //     <img className="dishPlaceholder" src={SalonPlaceHolder} />
              //   )}
              //   {/* <VegDishIcon className="dishPlaceholder" /> */}
              // </div>
            }
          </div>
          <div className="add-note">
            {props.itemDetail.enable &&
            props.menuAdd &&
            props.itemDetail?.isCategoryOff === false ? (
              <div>
                {(cartData && ( Number(cartData.quantity) > 0 && !props.customizable)) ||
              (props.menuAdd &&  isCartAdded ) ? (
                  <span id="favourite-detail-container">
                    {/* {isFavourite ? <HeartFilled /> : <HeartIcon />} */}
                    {/* <span>
              {`${props.likesCount} likes`}
            </span> */}

                    <SpecialNote
                      className={isSpecialNoteAdded ? "customised-icon" : ""}
                      id="customise-icon"
                      onClick={() => {
                        props.setShowSpeicalNotePromptID(
                          props.itemDetail.itemId
                        );
                      }}
                    />
                  </span>
                ) : null}
              </div>
            ) : null}
          </div>
          {(cartData && Number(cartData.quantity)
            ? Number(cartData.quantity)
            : 0) > 0 && props.menuAdd ? (
            <ItemCountSpinner
              size="small"
              count={
                itemIndividualCustomizationEnabled
                  ? individualCustomisedItemCount
                  : cartData && Number(cartData.quantity)
                  ? Number(cartData.quantity)
                  : 0
              }
              onPressDecrement={() => removeItem()}
              onPressIncrement={() =>
                // {if(Number(cartData?.quantity) ===
                //   Number(props?.itemDetail?.stockQuantity)){
                //     return null;
                //     console.log("++++++");
                //   }else{
                //     return(
                //       props.customizable && hasCustomization()
                //   ? customizeItem()
                //   : typeof props.itemDetail?.stockQuantity === "number"
                //   ? Number(cartData?.quantity) <
                //     props?.itemDetail?.stockQuantity
                //     ? addItem()
                //     : null
                //   : addItem()
                //     )
                //   }
                // }
                props.customizable && hasCustomization()  ? customizeItem()
                  : typeof props.itemDetail?.stockQuantity === "number"
                  ? Number(cartData?.quantity) <
                    props?.itemDetail?.stockQuantity
                    ? addItem()
                    : null
                  : addItem()
              }
              decrementDisabled={false}
            />
          ) : (
            <Fragment>
              {/* customization stock condition */}
              {props.itemDetail.enable && (
                // ((props.itemDetail.customization &&
                //   props.itemDetail.customization.length > 0 &&
                //   props.itemDetail.customization?.filter(
                //     (item) => item.typeAvailable === 1
                //   ).length === 0) ||
                //   (props.itemDetail.stockQuantity &&
                //     props.itemDetail.stockQuantity <= 0)) ? (
                //   <Fragment>
                //     <span className="stock-out">Out of stock</span>
                //   </Fragment>
                // ) :
                <Fragment>
                  {DineInTypeAvailable &&
                  props.itemDetail.enable &&
                  !props.itemDetail.isCategoryOff &&
                  (props.itemDetail.stockQuantity == null ||
                    Number(props?.itemDetail?.stockQuantity) > 0) ? (
                    // props.itemDetail.stockQuantity &&
                    <Fragment>
                      {props.itemDetail.description ||
                      hasCustomization() ||
                      props.menuAdd ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            position: "absolute",
                            top: "70px",
                            left: "0",
                            right: "0",
                          }}
                        >
                          {(orderTypes.includes("Delivery") ||
                            orderTypes.includes("Pickup")) && (
                            <div
                              className="add-button"
                              style={{
                                backgroundColor:
                                  currentRestaurantDetail.open === 0 && !props.menuView 
                                  ? "#979797"
                                  : currentRestaurantDetail.open === 1 && (!isContactlessDineInOrder && !cutOffTimeExceeds && !isEventOrders)
                                  ? "#979797" 
                                  : "#fff",

                                borderColor: "0.5px solid #c1c1c1",
                                color: 
                                  currentRestaurantDetail.open === 0 && !props.menuView
                                  ? "#fff"
                                  : currentRestaurantDetail.open === 1 && (!isContactlessDineInOrder && !cutOffTimeExceeds && !isEventOrders)
                                  ? "#fff" 
                                  : "#67833e",
                              }}
                              onClick={() => {
                                if(props.menuView){
                                  viewItem()
                                }else if (currentRestaurantDetail.open === 1 && (isContactlessDineInOrder || cutOffTimeExceeds || isEventOrders)) {                                  
                          
                                   if (props.menuAdd) {
                                    // Menu Add
                                    if (hasCustomization() || !hasCustomization()) {
                                      if (cartItems.length == 0) {
                                        dispatch(
                                          startEmptyCart({
                                            menuType: menuType,
                                            restaurantSlug: merchantSlug,
                                            clearCartItems: true,
                                            merchantType: merchantType,
                                          })
                                        );
                                        dispatch(startEmptyCartOrder())

                                        hasCustomization() &&customizeItem();
                                        !hasCustomization() && addItem();

                                      } else if (!isCartRoute) {
                                        setIsPopupOpen(true);
                                      } else {
                                        hasCustomization() && customizeItem();
                                        !hasCustomization() && addItem();

                                      }
                                    } else {
                                      // console.log(
                                      //   "inside Customization :::",
                                      //   props.menuAdd,
                                      //   cartItems
                                      // );

                                      if (cartItems.length == 0) {
                                        dispatch(
                                          startEmptyCart({
                                            menuType: menuType,
                                            restaurantSlug: merchantSlug,
                                            clearCartItems: true,
                                            merchantType: merchantType,
                                          })
                                        );
                                        dispatch(startEmptyCartOrder())

                                        if (
                                          props?.itemDetail &&
                                          props?.itemDetail?.itemBasedOffers ===
                                            null
                                        ) {
                                          addItem();
                                        } else if (
                                          props?.itemDetail &&
                                          props?.itemDetail?.itemBasedOffers !==
                                            null &&
                                          AppAuth?.userState === "guest"
                                        ) {
                                          setloginRequestPopup(true);
                                        } else {
                                          addItem();
                                        }
                                      } else if (!isCartRoute) {
                                        setIsPopupOpen(true);
                                      } else {
                                        if (
                                          props?.itemDetail &&
                                          props?.itemDetail?.itemBasedOffers !==
                                            null &&
                                          AppAuth?.userState === "guest"
                                        ) {
                                          setloginRequestPopup(true);
                                        } else {
                                          addItem();
                                        }

                                        // addItem();
                                      }
                                    }
                                  }
                                }
                              }}
                            >
                              <span
                                className="view-btn"
                                onClick={() => {
                                  //!props.menuAdd && customizeItem();
                                }}
                              >
                                {props.menuAdd ? "Add" : "View"}
                              </span>
                            </div>
                          )}
                          <p className="customizable-text">
                            {props.menuAdd && hasCustomization()
                              ? "Customizable"
                              : null}
                            {!props.menuAdd &&
                            (!hasCustomization() ||
                              props.itemDetail.description)
                              ? "More Details"
                              : null}
                          </p>
                        </div>
                      ) : null}
                    </Fragment>
                  ) : null}
                </Fragment>
              )}
            </Fragment>
          )}
          {!props.itemDetail.enable && props.itemDetail.itemUnAvailableUntil ? (
            <div className="item-unavail">
              {new Date(props.itemDetail.itemUnAvailableUntil).getFullYear() >
              3000 ? (
                "Temporarily Unavailable"
              ) : (
                <Fragment>
                  {get12HoursTime(props.itemDetail.itemUnAvailableUntil,props.itemDetail.nextAvailableDay!=null ?
                  props.itemDetail.nextAvailableDay :"")}
                </Fragment>
              )}
            </div>
          ) : (
            <span></span>
          )}
          {(isItemAvailableOnCurrentServiceWindow() && !props.itemDetail.itemUnAvailableUntil &&
            (!props.itemDetail.enable ||
              Number(cartData?.quantity) ===
                Number(props?.itemDetail?.stockQuantity))) ? (
            <div className="stock-out-container" style={{ textAlign: "center",
             }}>
              <span className="stock-out-a one">Only {props?.itemDetail?.stockQuantity} available!</span>
            </div>
          ) : null}

               {
          (props.itemDetail.stockQuantity !== null &&
            Number(props.itemDetail.stockQuantity) < 1)
            || props.itemDetail.isCategoryOff == true
            ? (
            <div className="stock-out-container" style={{ textAlign: "center",
             }}>
              <span className="stock-out one">Out of stock</span>
            </div>
          ) : null}

        </div>
      </div>
      {props?.itemDetail &&
      props?.itemDetail?.itemBasedOffers !== null &&
      props?.itemDetail?.itemBasedOffers?.length > 0 ? (
        <>
          <div className="offer_div">
            {props?.itemDetail?.itemBasedOffers &&
            props?.itemDetail?.itemBasedOffers.length > 1 ? (
              <span
                className={
                  !is_add
                    ? "display-block multi_offer"
                    : "display-none multi_offer"
                }
                onClick={() => setisadd(!is_add)}
              >
                This item has offers
              </span>
            ) : (
              props?.itemDetail?.itemBasedOffers &&
              props?.itemDetail?.itemBasedOffers.length > 0 &&
              props?.itemDetail?.itemBasedOffers.length === 1 &&
              (props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                .itemDetails.offersAppliedAt === "Q" ? (
                <span className="multi_span">
                  {props?.itemDetail?.itemBasedOffers[0].offerType ===
                  "PERCENT" ? (
                    <>
                      Add
                      {
                        props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                          .itemDetails?.itemQuantity
                      }
                      items for
                      {props?.itemDetail?.itemBasedOffers[0].offerRate}% off(Max
                      <PriceOffer />
                      {props?.itemDetail?.itemBasedOffers[0].maxDiscount})
                    </>
                  ) : (
                    <>
                      Add
                      {
                        props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                          .itemDetails?.itemQuantity
                      }
                      items for&nbsp;
                      <PriceOffer />
                      {props?.itemDetail?.itemBasedOffers[0].maxDiscount} off
                    </>
                  )}
                </span>
              ) : (
                props?.itemDetail?.itemBasedOffers.length > 0 &&
                props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                  .itemDetails.offersAppliedAt === "S" && (
                  <span className="multi_span">
                    {props?.itemDetail?.itemBasedOffers[0].offerType ===
                    "PERCENT" ? (
                      <>
                        Add
                        {props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                          .itemDetails?.scaleLevel - 1}
                        -
                        {
                          props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                            .itemDetails?.scaleLevel
                        }
                        items for
                        {props?.itemDetail?.itemBasedOffers[0].offerRate}% off
                      </>
                    ) : (
                      <>
                        Add
                        {props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                          .itemDetails?.scaleLevel - 1}
                        -
                        {
                          props?.itemDetail?.itemBasedOffers[0]?.offerAttributes
                            .itemDetails?.scaleLevel
                        }
                        items for <PriceOffer />
                        {props?.itemDetail?.itemBasedOffers[0].maxDiscount} off
                      </>
                    )}
                  </span>
                )
              ))
            )}
            {/* props.itemDetail.itemBasedOffers.map((i, j) => i.itemId)} */}
          </div>
        </>
      ) : (
        ""
      )}
      {is_add ? (
        <span className="multi_span">
          {props?.itemDetail?.itemBasedOffers?.map((i, j) => {
            //  console.log(i, "checking ii");
            return i?.offerAttributes.itemDetails.offersAppliedAt === "Q" ? (
              <span style={{ display: "flex", alignItems: "center" }}>
                {i.offerType === "PERCENT" ? (
                  <>
                    Add {i?.offerAttributes.itemDetails?.itemQuantity} items for
                    {i.offerRate}% off(Max&nbsp;
                    <PriceOffer />
                    {i.maxDiscount} off)
                  </>
                ) : (
                  <>
                    Add {i?.offerAttributes.itemDetails?.itemQuantity} items
                    for&nbsp;
                    <PriceOffer />
                    {i.maxDiscount} off
                  </>
                )}
              </span>
            ) : (
              i?.offerAttributes.itemDetails.offersAppliedAt === "S" && (
                <span style={{ display: "flex" }}>
                  {i.offerType === "PERCENT" ? (
                    <>
                      Add {i?.offerAttributes.itemDetails?.scaleLevel - 1}-
                      {i?.offerAttributes.itemDetails?.scaleLevel} items for
                      {i.offerRate}% off
                    </>
                  ) : (
                    <>
                      Add {i?.offerAttributes.itemDetails?.scaleLevel - 1}-
                      {i?.offerAttributes.itemDetails?.scaleLevel} items
                      for&nbsp;
                      <PriceOffer />
                      {i.maxDiscount} off
                    </>
                  )}
                </span>
              )
            );
          })}
        </span>
      ) : (
        ""
      )}
    </div>
  );
});

export default DishCard;
